<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <size-select id="size-select" class="right-menu-item hover-effect" />
      </template>

      <notification class="right-menu-item hover-effect" />
      <el-popover>
        <div style="max-height: 50vh; overflow-y: auto">
          <div v-for="item in accountSetList" :key="item.code">
            <el-button type="text" @click="switchAccountSet(item)">{{
              item.alias
            }}</el-button>
          </div>
        </div>
        <div
          slot="reference"
          class="avatar-container right-menu-item hover-effect"
        >
          <div class="avatar-wrapper">
            {{ currentAccountSet ? currentAccountSet.alias : "" }}
            <i class="el-icon-caret-bottom" />
          </div>
        </div>
      </el-popover>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span v-if="user">
            {{ user.storeName }}
            <span v-if="user.cashier_name">: {{ user.cashier_name }}</span>
          </span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span style="display: block" @click="logout">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import ErrorLog from '@/components/ErrorLog';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
import Search from '@/components/HeaderSearch';
import Notification from '@/components/Notification';
import { getCurrentAccountSet } from '@/api/accountSet.js';
import { findAccountSet, selectAccountSet } from '@/api/accountSet';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search,
    Notification
  },
  data () {
    return {
      accountSetList: []
    }
  },
  computed: {
    currentAccountSet () {
      return getCurrentAccountSet();
    },
    ...mapGetters(['sidebar', 'avatar', 'device', 'user'])
  },
  async created () {
    try {
      var response = await findAccountSet();
      this.accountSetList = response.data.list;
      this.$store.commit('app/SET_ACCOUNTLIST', response.data.list)
    } catch {
    }
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout () {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    async switchAccountSet (item) {
      if (this.currentAccountSet.code == item.code) {
        return;
      }
      try {
        await this.$confirm(`您确认要切换到账套【${item.alias || item.name}】吗?`, '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await selectAccountSet(item);
        await this.$store.dispatch('tagsView/delAllViews');
        location.href = '/';
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 19px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
